import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import Committee from "@/pages/Committee";
import Sponsors from "@/pages/Sponsors";
import LiveResults from "@/pages/LiveResults";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Program from "@/pages/Program";
import UpdateAddress from "@/pages/UpdateAddress";
import WithdrawNomination from "@/pages/WithdrawNomination";
import WithdrawSelf from "@/pages/WithdrawSelf";
import { API } from "@/lib/api";
import "@/App.css";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: location.pathname }),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="grain min-h-screen bg-clay-bg text-clay-text">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/live-results" element={<LiveResults />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/program/:eventId" element={<Program />} />
          <Route path="/update-address/:token" element={<UpdateAddress />} />
          <Route path="/withdraw-nomination/:token" element={<WithdrawNomination />} />
          <Route path="/withdraw-nomination" element={<WithdrawSelf />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
